import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DataTable, PaginatedList, Spinner, NoSearchResult } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import SyncedTeamsOverviewItem from "./SyncedTeamsOverviewItem";
import SyncedTeamsFilter from "./SyncedTeamsFilter";
import LicenseCheck from "../../license/LicenseCheck";
import { useSyncedTeamsPaginated } from "../hooks/useTeamSync";
const DEFAULT_PAGINATION = {
  page: 1,
  perPage: 10,
  query: ""
};
const _headerCellFormatter = (header) => {
  switch (header.toLocaleLowerCase()) {
    case "actions":
      return /* @__PURE__ */ React.createElement("th", { className: "actions text-right" }, header);
    default:
      return /* @__PURE__ */ React.createElement("th", null, header);
  }
};
const SyncedTeamsSection = ({ authenticationBackend }) => {
  const { t } = useTranslation("enterprise_authentication");
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const { page } = pagination;
  const { data: paginatedTeams, isFetching } = useSyncedTeamsPaginated(authenticationBackend.id, pagination);
  if (!paginatedTeams) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const searchFilter = /* @__PURE__ */ React.createElement(
    SyncedTeamsFilter,
    {
      onSearch: (newQuery) => setPagination({ ...pagination, query: newQuery, page: DEFAULT_PAGINATION.page })
    }
  );
  const tableHeaders = [
    t("synced_teams_section.table_headers.name"),
    t("synced_teams_section.table_headers.users"),
    t("synced_teams_section.table_headers.roles")
  ];
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: t("synced_teams_section.title"), showLoading: isFetching }, /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement("p", { className: "description" }, t("synced_teams_section.found", { total: paginatedTeams.pagination.total })), /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      activePage: page,
      totalItems: paginatedTeams.pagination.total,
      onChange: (newPage, newPerPage) => setPagination({
        ...pagination,
        page: newPage,
        perPage: newPerPage
      }),
      useQueryParameter: false
    },
    /* @__PURE__ */ React.createElement(
      DataTable,
      {
        customFilter: searchFilter,
        dataRowFormatter: (team) => /* @__PURE__ */ React.createElement(
          SyncedTeamsOverviewItem,
          {
            team,
            rolesContext: paginatedTeams.context.roles,
            usersContext: paginatedTeams.context.users
          }
        ),
        filterKeys: [],
        filterLabel: t("synced_teams_section.filter_label"),
        headerCellFormatter: _headerCellFormatter,
        headers: tableHeaders,
        id: "synced-teams-overview",
        noDataText: /* @__PURE__ */ React.createElement(NoSearchResult, null, t("synced_teams_section.no_data")),
        rowClassName: "no-bm",
        rows: paginatedTeams.list.toJS(),
        sortByKey: "name"
      }
    )
  )));
};
export default SyncedTeamsSection;
